/**
 * Var slutar navbaren?
 *
 * Navbaren är varken fixed eller sticky, och varje sida renderar sin egen. En
 * komponent som ska ligga precis under den måste därför mäta i stället för att
 * anta en höjd. När sidan scrollats förbi navbaren blir underkanten negativ och
 * klampas till 0 — då lägger sig panelen/bannern i skärmens överkant.
 *
 * Saknas navbaren helt (inloggning, presentationsvyerna) blir svaret 0, vilket
 * är rätt: då finns inget att ligga under.
 */

import { useEffect, useState } from 'react';

export const navbarensUnderkant = () => {
  const navbar = document.querySelector('[data-app-navbar]');
  if (!navbar) return 0;
  return Math.max(0, Math.round(navbar.getBoundingClientRect().bottom));
};

/**
 * Följer navbarens underkant medan `aktiv` är sant.
 *
 * Lyssnarna sätts bara upp när något faktiskt ligger dockat — annars hade varje
 * scroll i hela portalen kostat en mätning i onödan.
 *
 * @param {boolean} aktiv
 * @returns {number} px från skärmens överkant
 */
export const useNavbarOffset = (aktiv) => {
  const [toppOffset, setToppOffset] = useState(0);

  useEffect(() => {
    if (!aktiv) {
      setToppOffset(0);
      return;
    }

    const mat = () => setToppOffset(navbarensUnderkant());
    mat();

    window.addEventListener('scroll', mat, { passive: true });
    window.addEventListener('resize', mat);
    return () => {
      window.removeEventListener('scroll', mat);
      window.removeEventListener('resize', mat);
    };
  }, [aktiv]);

  return toppOffset;
};
